<script setup=""></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 32 32">
    <path
      fill="currentColor"
      d="M27 22.524A3.476 3.476 0 0 1 23.524 26H9.476A3.476 3.476 0 0 1 6 22.524V8.476A3.476 3.476 0 0 1 9.476 5h14.048A3.476 3.476 0 0 1 27 8.476v14.048Z"
    />
    <path
      fill="#fff"
      d="M11.895 10.561V8.12c0-.299.234-.541.524-.541.289 0 .524.242.524.54v2.442c0 2.025 1.595 3.673 3.557 3.673 1.961 0 3.557-1.648 3.557-3.673V8.12c0-.299.235-.541.524-.541.29 0 .524.242.524.54v2.442c0 2.622-2.066 4.755-4.605 4.755-2.54 0-4.605-2.133-4.605-4.755Zm12.157 12.492h-1.239l-2.122-2.627v2.627h-1.428v-4.421H20.5l2.122 2.675v-2.675h1.43v4.42Z"
    />
  </svg>
</template>
